export const DEFAULT_BRUSH_ATTRIBUTES = {
    trigger: "pointerdown",
    updateTrigger: "pointermove",
    endTrigger: [ "pointerup", "pointerleave" ],
    resetTrigger: "pointerupoutside",
    hasMask: !0,
    brushMode: "single",
    brushType: "rect",
    brushStyle: {
        fill: "#B0C8F9",
        fillOpacity: .2,
        stroke: "#B0C8F9",
        strokeWidth: 2
    },
    brushMoved: !0,
    removeOnClick: !0,
    delayType: "throttle",
    delayTime: 10,
    interactiveRange: {
        minY: -1 / 0,
        maxY: 1 / 0,
        minX: -1 / 0,
        maxX: 1 / 0
    }
};

export const DEFAULT_SIZE_THRESHOLD = 5;
//# sourceMappingURL=config.js.map